const getLocalStorage = (): Storage => localStorage;
const getSessionStorage = (): Storage => sessionStorage;

export { getLocalStorage, getSessionStorage };
